module.exports = __webpack_public_path__ + "img/zhaopin.7a941170.jpg";